import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterModule, RouterOutlet, ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { PusherService } from './_service/pusher.service';
import { SharedModule } from './shared/shared.module';
import { BuzzService } from './_service/buzz.service';
import { OrderNotificationService } from './_service/order-notification.service';
import { ChatNotificationService } from './_service/chat-notification.service';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from './_service/notification.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterModule, LoadingBarModule, LoadingBarHttpClientModule, SharedModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'dotalink_waiter';
  newOrderCount: number = 0;
  notificationCount: number = 0;
  showBackButton = false;
  userDet: any;
  apkUrl: string = "https://rolak.waiter.qrserve.ng/app-release.apk"; // Replace with your APK URL

  downloadAPK() {
    const link = document.createElement('a');
    link.href = this.apkUrl;
    link.setAttribute('download', 'app-release.apk'); // Sets the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  private cleanupInterval?: any;

  constructor(
    private pusherService: PusherService,
    private buzzService: BuzzService,
    private orderNotificationService: OrderNotificationService,
    private chatNotificationService: ChatNotificationService,
    private toastr: ToastrService,
    private notificationService: NotificationService,
    private router: Router, private location: Location
  ) { 
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showBackButton = event.url !== '/home/orders'; // Hide back button on home
      }
    });
  }

  ngOnInit(): void {
    var userD = JSON.parse(localStorage.getItem('user') || '{}');
    this.initializePusherSubscriptions();
    this.userDet = userD;
    this.notificationService.notificationCount$.subscribe(count => {
      this.notificationCount = count;
    });
    // Clean up expired buzzes every hour
    this.cleanupInterval = setInterval(() => {
      this.buzzService.clearExpiredBuzzes(60); // Clear buzzes older than 60 minutes
    }, 60 * 60 * 1000); // Run every hour
  }

  ngOnDestroy(): void {
    if (this.cleanupInterval) {
      clearInterval(this.cleanupInterval);
    }
  }
  goBack(): void {
    this.location.back(); // Navigate back
  }

  refreshPage(): void {
    window.location.reload(); // Reload the page
  }
  private initializePusherSubscriptions(): void {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const tenant = user.user.tenant;
    const mes = `waiter-notification-${tenant}-all`;

    console.log('Initializing Pusher subscriptions...');

    // Subscribe to channel once
    const waiterChannel = this.pusherService.subscribeToChannel('waiter-notification');

    // Bind multiple events to the same channel
    waiterChannel.bind(mes, (data: any) => {
      this.handleWaiterNotifications(data, user);
    });
    // console.log(`waiter-notification-${user.user.pusher_id}`);
    waiterChannel.bind(`waiter-notification-${user.user.pusher_id}`, (data: any) => {
      this.handlePersonalWaiterNotifications(data, user);
    });
  }

  private handleWaiterNotifications(data: any, user: any) {
    console.log('Notification data:', data);
    if (data.type === "order_partial_payment") {
      if (data.waiter_id === user.user.pusher_id) {
        this.playBeep();
        this.showNotification(data.details);
        // Emit the order ID that received a partial payment
        this.pusherService.emitPartialPaymentEvent(data.data.uid);
      }
    } else if (data.type === "buzz") {
      this.playBeep();
      const message = `${data.table} needs your attention`;
      this.showNotification(message);
      // Add buzz to service instead of dispatching event
      this.buzzService.addBuzz({
        table: data.table,
        reason: data.reason,
        timestamp: new Date(),
        orderId: data.order_id
      });
    } else if (data.type === "new_order") {
      this.playBeep();
      const message = `There's a new order`;
      this.showNotification(message);
      // Use the service instead of local count
      this.orderNotificationService.incrementCount();
    } else if (data.type === "new_order_same_table") {

      const message = `There's a new order from ${data.barcode_details.name}`;
      if (data.waiter_id === user.user.pusher_id) {
        this.playBeep();
        this.showNotification(message);
        // Use the service instead of local count
        this.orderNotificationService.incrementCount();
      }
    } else if (data.type === "order_modified") {
      const message = data.details;
      if (data.waiter_id === user.user.pusher_id) {
        this.playBeep();
        this.showNotification(message);
        // Use the service instead of local count
        this.orderNotificationService.incrementCount();
      }
    } else if (data.type === "chat" && data.waiter_id === user.user.pusher_id) {
      this.playBeep();
      const message = `Message from ${data.name}`;
      this.showNotification(message);
      // Add chat notification for the order
      this.chatNotificationService.addChatNotification(data.order_id);
    } else if (data.type === "pos_payment" && data.waiter_id === user.user.pusher_id) {
      // Forward the POS payment event to the payment method component via a service
      this.pusherService.emitPosPaymentEvent(data);
    } else if (data.type === "order_completed" && data.waiter_id === user.user.pusher_id) {
      this.playBeep();
      // Emit the order ID that received a partial payment
      this.pusherService.emitPartialPaymentEvent(data.data.uid);
    }
    console.log('Notification data:', data);
  }

  private handlePersonalWaiterNotifications(data: any, user: any) {
    // Handle personal notifications
    if (data.type === "buzz") {
      this.playBeep();
      const message = `${data.table} needs your attention`;
      this.showNotification(message);
      // Add buzz to service instead of dispatching event
      this.buzzService.addBuzz({
        table: data.table,
        reason: data.reason,
        timestamp: new Date(),
        orderId: data.order_id
      });
    }
    console.log('Personal notification:', data);
  }

  private playBeep() {
    const audio = new Audio('beep.mp3');
    audio.load();
    audio.play().catch(error => {
      console.error("Error playing audio", error);
    });
  }

  private showNotification(message: string) {
    this.toastr.info(message, 'Notification', {
      timeOut: 20000,
      positionClass: 'toast-top-right',
      closeButton: true,
      progressBar: true
    });
    // Increment notification count
    this.notificationService.incrementCount();
  }
}
